import { template as template_23bb3220aa29496aacb912978d8b8975 } from "@ember/template-compiler";
import { componentFor } from 'client-portal/utils/clinicianSearch/facets/manifest';
import Component from '@glimmer/component';
export default class RequestClinicianSearchFacetFilterContent extends Component {
    get facetComponent() {
        return componentFor(this.args.facetName);
    }
    static{
        template_23bb3220aa29496aacb912978d8b8975(`
    {{#if this.facetComponent}}
      <this.facetComponent />
    {{/if}}
  `, {
            component: this,
            eval () {
                return eval(arguments[0]);
            }
        });
    }
}
